








import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { StickyType } from './model/Types'

interface WrapperStyles {
  height: string | null
  'min-height': string | null
}

interface StickyStyles {
  top: string | null
  width: string | null
  bottom: string | null
}

@Component
export default class Sticky extends Vue {

  @Prop({ required: true })
  type: StickyType

  @Prop({ default: 0 })
  offsetTop: number

  @Prop({ default: 0 })
  marginTop: number

  @Prop({ default: 0 })
  offsetBottom: number

  @Prop({ default: '' })
  stickyClass: string

  @Prop({ default: true })
  excludeHeader: boolean

  isSticky: boolean = false

  wrapperStyles: WrapperStyles = {
    height: null,
    'min-height': null,
  }

  stickyStyles: StickyStyles = {
    top: null,
    width: null,
    bottom: null,
  }

  mounted() {

    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('resize', this.handleResize, { passive: true })

    // ページ表示直後から機能させる
    this.$nextTick(() => this.handleScroll())
  }

  beforeDestroy() {

    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }

  stickyElement() {

    const rect = this.$el.getBoundingClientRect()
    const scrollTop = window.pageYOffset
    const scrollLeft = window.pageXOffset

    const body = window.document.body
    const clientTop = body.clientTop || 0
    const clientLeft = body.clientLeft || 0

    return {
      top: rect.top + scrollTop - clientTop,
      left: rect.left + scrollLeft - clientLeft,
      width: rect.width,
      height: rect.height,
    }
  }
  get headerHeight(): number {

    const header = document.querySelector('header')
    if (!this.excludeHeader || !header) {
      return 0
    }

    const clientRect = header.getBoundingClientRect()

    return clientRect ? clientRect.height : 0
  }

  stickyTopPosition(): number {
    return this.stickyElement().top - (this.headerHeight + this.offsetTop + this.marginTop)
  }

  stickyBottomPosition(): number {
    return this.stickyElement().top + this.offsetBottom + this.htmlElement.offsetHeight
  }

  private get htmlElement(): HTMLElement {
    return this.$el as HTMLElement
  }

  handleResize() {

    if (this.isSticky) {
      this.stickyStyles.width = `${this.htmlElement.offsetWidth}px`
    }
  }

  handleScroll(): void {
    const sticky = this.isSticky
    const stickyElement = this.stickyElement()
    const stickyWidth = this.htmlElement.offsetWidth

    switch (this.type) {
      case StickyType.TOP:

        const fixTop = this.headerHeight + this.offsetTop + this.marginTop
        const scrollTop = window.pageYOffset
        const topPosition = this.stickyTopPosition()

        if (topPosition <= scrollTop && !sticky) {
          this.isSticky = true
          this.wrapperStyles = {
            height: `${stickyElement.height}px`,
            'min-height': `${stickyElement.height}px`,
          }
          this.stickyStyles = {
            top: `${fixTop}px`,
            width: `${stickyWidth}px`,
            bottom: null,
          }
        } else if (topPosition > scrollTop && sticky) {
          this.resetStyles()
        }
        break
      case StickyType.BOTTOM:

        const scrollBottom = window.pageYOffset + window.innerHeight
        const bottomPosition = this.stickyBottomPosition()

        if (bottomPosition > scrollBottom && !sticky) {
          this.isSticky = true
          this.wrapperStyles = {
            height: `${stickyElement.height}px`,
            'min-height': `${stickyElement.height}px`,
          }
          this.stickyStyles = {
            top: null,
            bottom: `${this.offsetBottom}px`,
            width: `${stickyWidth}px`,
          }
        } else if (bottomPosition < scrollBottom && sticky) {
          this.resetStyles()
        }
        break
      default:
        return
    }
  }

  resetStyles() {

    this.isSticky = false
    this.wrapperStyles = {
      height: null,
      'min-height': null,
    }
    this.stickyStyles = {
      top: null,
      width: null,
      bottom: null,
    }
  }
}
